import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import { JobBoardPosting } from '@recruitee/job-boards-types';

import {
  JobBoardCredentialPostingActions,
  JobBoardCredentialPostingSelectors,
} from './credential-posting.store';

@Injectable({ providedIn: 'root' })
export class JobBoardCredentialPostingStoreService {
  private readonly store = inject(Store);

  public getCredentialPostings(
    codename: string,
    credentialId: number,
  ): Observable<JobBoardPosting[]> {
    return this.store
      .select(JobBoardCredentialPostingSelectors.entities({ scope: `${codename}:${credentialId}` }))
      .pipe(filterBoolean);
  }

  public getCredentialPostingsLoading(codename: string, credentialId: number): Observable<boolean> {
    return this.store.select(
      JobBoardCredentialPostingSelectors.isPending({
        scope: `${codename}:${credentialId}`,
      }),
    );
  }

  public fetchCredentialPostings(codename: string, credentialId: number): void {
    this.store.dispatch(
      JobBoardCredentialPostingActions.fetchCollection({
        payload: { scope: `${codename}:${credentialId}` },
      }),
    );
  }
}
